import { ApiService }        from '../../app-lite/api/api.service';
import { CompanyMessagesModel } from '../../app-lite/companies/models/company.messages';
import { TableService }         from '../../app-lite/table/table.service';

import StatementsHtml from './statements.html';

export function StatementsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'StatementsCtrl',
    name       : 'app.statements',
    templateUrl: StatementsHtml,
    url        : '/statements',
    resolve    : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      constraints    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/statement_constraint_types'),
      customers      : ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('statements');

        return workshopAPI.get('/customers/customer_list_for_statements', [
          cache.filtering.begin_date      ? cache.filtering.begin_date      : '*',
          cache.filtering.end_date        ? cache.filtering.end_date        : '*',
          cache.filtering.include_paid    ? cache.filtering.include_paid    : false,
          cache.filtering.as_at           ? cache.filtering.as_at           : '*',
          cache.filtering.begin_date      ? cache.filtering.statement       : 'false',
          cache.sorting.field     || 'customer.display_name',
          cache.sorting.direction || 'asc',
          cache.filtering.constraint_type ? cache.filtering.constraint_type : '*',
          0,
          cache.paging.pageSize   || 10
        ]);
      },
    }
  });
};